import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';

function BasicDelete({ closeModal, open, handleConfirmation, Header, Footer, Body }) {
  return (
    <AppModal open={open} closeModal={closeModal} size="md">
      <AppModalHeader>{Header}</AppModalHeader>
      <AppModalBody>
        <p className="modal-sub-text">{Body}</p>

        <div className="app-l-modal-btn-block">
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={handleConfirmation}>
            YES<sup>*</sup>
          </AppButton>
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
            NO
          </AppButton>
        </div>

        <p className="modal-sub-note">
          <sup>*</sup>Please note that this action is irreversible
        </p>
      </AppModalBody>
      {/* <AppModalFooter></AppModalFooter> */}
    </AppModal>
  );
}

BasicDelete.defaultProps = {
  Header: 'Delete confirmation required!',
  Body: 'Are you sure? This process cannot be undone.',
  Footer: null,
  closeModal: () => {},
  handleConfirmation: () => {},
};

export default BasicDelete;
